import axiosInstance from "../utils/axiosConfig";
import { getErrorMessage } from "../utils/errorHandler";

const fetchMotoristas = async () => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest2/";
  const apiUrl = `${baseUrl}INT_PAPELETA_WSMOTORISTAS`;

  try {
    const response = await axiosInstance.get(apiUrl, {
      timeout: 10000, // Aumentar timeout para 10 segundos
    });

    return response.data; // Retorna os dados da resposta
  } catch (error) {
    console.error("Erro ao fazer a requisição:", error);
    console.log("🔍 DEBUG API: Tipo do erro:", typeof error);
    console.log("🔍 DEBUG API: Código do erro:", error.code);
    console.log("🔍 DEBUG API: Mensagem do erro:", error.message);
    console.log("🔍 DEBUG API: Status do erro:", error.response?.status);
    console.log("🔍 DEBUG API: Dados do erro:", error.response?.data);
    console.log("🔍 DEBUG API: isSSLError:", error.isSSLError);

    // Tratamento específico para erros de certificado SSL
    // Tratamento específico para erro 503 (Service Unavailable)
    if (error.response && error.response.status === 503) {
      console.log("🚨 Erro 503 detectado! Serviço indisponível");
      
      // Verificar se é erro de licença
      const errorData = error.response.data;
      if (errorData && errorData.message && errorData.message.includes("licenca")) {
        throw new Error("Erro de Licença: Não há licenças disponíveis no servidor no momento. Tente novamente mais tarde.");
      }
      
      // Erro 503 genérico
      throw new Error("Serviço temporariamente indisponível. O servidor está sobrecarregado ou em manutenção. Tente novamente em alguns instantes.");
    }

    // Se o erro for de timeout, limpa o localStorage
    // Usar o utilitário para tratar todos os tipos de erro de forma consistente
    throw new Error(getErrorMessage(error, "buscar motoristas"));
  }
};

export { fetchMotoristas };
